/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  rebateProgram: [],
  errorMsgDisputeCode: [],
  rebateProgramName: {},

  open: true,
  closed: false,
  startQtr: '',
  endQtr: '',
  exportAllData: [],
  selectedValue: '-1',
  drugSelection: 'Dispute',
  selectedDisputeCodes: 'All',
  disputeCodeReport: [],
  manufactureWithIds: [],
  allManufacturer: [],
  allCode: [],
  selectedOptionDisputeCode: [],
  manufacturerList: {},
  displayObj: {
    allManufacturer: [],
    allCode: [],
    rebateProgramName: {},
    manufactureWithIds: [],
    selectedValue: '-1',
    disputeCodeReport: [],
    selectedOptionDisputeCode: [],
    drugSelection: 'Dispute',
    startQtr: '',
    endQtr: '',
    manufacturerList: {},
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_CODE:
      return { ...state, performDisputeResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_CODE:
      return { ...state, disputeResolutionDetailObj: action.detailScrData };

    case actionTypes.GET_ERROR_MSG_DISPUTE_CODE:
      return { ...state, errorMsgDisputeCode: action.payload };
    case actionTypes.SEARCH_MFG_DISP_ACTIVITY:
      return { ...state, mfgListSelected: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_CODE:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_CODE:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_CODE:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.MANUFACTURER_GRID_CODE:
      return { ...state, manufacturerList: action.manufacturerList };
    case actionTypes.SELECTED_DISPUTE_CODE:
      return { ...state, selectedCode: action.payload };
    case actionTypes.SELECT_MANUFACTURER_CODE:
      return { ...state, selectedValue: action.manufactureCode };
    case actionTypes.GET_MANUFACTURER_NAME_CODE:
      return { ...state, allManufacturer: action.allManufacturer };
    case actionTypes.GET_MANUFACTURER_ID_CODE:
      return { ...state, manufactureWithIds: action.manufactureWithIds };
    case actionTypes.GET_CODE_NAME_CODE:
      return { ...state, allCode: action.allCode };
    case actionTypes.SELECT_DISPUTE_CODE_OPTION:
      return { ...state, selectedOptionDisputeCode: action.payload };
    case actionTypes.GET_DISPUTE_CODE_REPORT:
      let displayObj = {
        ...state.displayObj,
        disputeCodeReport: action.payload,
      };
      return { ...state, disputeCodeReport: action.payload, displayObj };

    case actionTypes.GET_DRUG_SELECTION:
      return { ...state, drugSelection: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_CODE:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };

    case actionTypes.SET_REFRESH_DATA_CODE:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        rebateProgram: [],
        errorMsgDisputeCode: [],
        rebateProgramName: {},

        open: true,
        closed: false,
        startQtr: '',
        endQtr: '',
        exportAllData: [],
        selectedValue: '-1',
        drugSelection: 'Dispute',
        selectedDisputeCodes: 'All',
        disputeCodeReport: [],
        manufactureWithIds: [],
        allManufacturer: [],
        selectedOptionDisputeCode: [],
      };
    case actionTypes.REFRESH_DISPUTE_CODE_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    case actionTypes.SET_STATUS_CODE:
      return { ...state, ...action.payload };
    case actionTypes.SET_QUARTER_RANGE_CODE:
      return { ...state, ...action.payload };

    case actionTypes.SET_EXPORT_ALL_CODE:
      const data =
        action.payload.key == undefined
          ? {}
          : {
              [action.payload.key]: action.payload.data,
              ...state.exportAllData,
            };
      return {
        ...state,
        exportAllData: data,
      };
    case actionTypes.SET_PAGINATION_INDEX_DISPUTE_CODES:
      return {
        ...state,
        displayObj: {
          ...state.displayObj,
          countValue: action.payload,
        },
      };
    default:
      return state;
  }
};
export default reducer;
